import {
  createCoding,
  ExtensionUrl,
  filterExtensions,
  medpraxSystem,
  type RequiredCoding,
} from '@quromedical/fhir-common';

import type { MedpraxPageResult } from '../external-integrations';

/**
 * @deprecated used for storing ICD10 on patient, the new coding needs it to be stored on an
 * Encounter
 */
export const mapICD10CodeToExtension = (
  code: MedpraxPageResult,
): fhir4.Extension => ({
  url: ExtensionUrl.admissionICD10Code,
  valueCoding: createCoding(code.Code, code.Description, medpraxSystem),
});

export const getExtensionCodingValue = (
  extension: fhir4.Extension,
): fhir4.Coding | undefined => extension.valueCoding;

export const isRequiredCoding = (
  coding?: fhir4.Coding,
): coding is RequiredCoding => !!coding?.code;

export const getAdmissionICD10CodesFromExtension = (
  extension?: fhir4.Extension[],
): RequiredCoding[] => {
  const result = filterExtensions(ExtensionUrl.admissionICD10Code, extension)
    .map(getExtensionCodingValue)
    .filter(isRequiredCoding);

  return result;
};
